import React from 'react';
import { Box } from '@mui/material';
import ProfilePicture from './ProfilePicture';
import CoverPhoto from './CoverPhoto';
import CompanyLogo from './CompanyLogo';

const ProfilePhotoCoverPhotoCompanyLogo = ({
  onCroppedProfilePictureBlob,
  onDeleteProfilePicture,
  onDeleteCompanylogo,
  onDeleteCoverPhoto,
  onCroppedCoverPhotoBlob,
  onCroppedCompanyLogoBlob,
  cardLayout,
  cardDesign
}) => {

  const handleProfilePictureCrop = (blob) => {
    onCroppedProfilePictureBlob(blob);
  };

  const handleCoverPhotoCrop = (blob) => {
    onCroppedCoverPhotoBlob(blob);
  };

  const handleCompanyLogoCrop = (blob) => {
    onCroppedCompanyLogoBlob(blob);
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 2,
          marginTop: "30px"
        }}
      >
        <ProfilePicture
          onCroppedImage={handleProfilePictureCrop}
          cardLayout={cardLayout}
          onDeleteProfilePicture={onDeleteProfilePicture}
          cardDesign={cardDesign}
        />
        <CoverPhoto
          onCroppedImage={handleCoverPhotoCrop}
          onDeleteCoverPhoto={onDeleteCoverPhoto}
        />
        <CompanyLogo
          onCroppedImage={handleCompanyLogoCrop}
          onDeleteCompanylogo={onDeleteCompanylogo}
        />

      </Box>
    </div>
  );
};

export default ProfilePhotoCoverPhotoCompanyLogo;